var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDecoLineBottom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 664,
    height: 47,
    viewBox: "0 0 664 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_313_140777)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_313_140777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M652.925 2.89537C656.786 0.863684 662.151 2.31338 662.546 6.24976C662.607 6.90441 662.501 7.56221 662.232 8.18237C661.964 8.80254 661.54 9.37185 660.986 9.85501C660.433 10.3382 659.761 10.7249 659.014 10.9912C658.267 11.2575 657.459 11.3976 656.641 11.403H655.916C654.335 11.403 652.727 11.403 651.145 11.403L367.447 11.403C360.014 11.403 352.804 11.6358 345.713 13.8897C340.526 15.5471 335.753 17.9416 331.624 20.9583C330.491 21.7837 332.165 23.1275 333.298 22.3022C341.218 16.5545 351.499 13.3523 362.175 13.3077C363.401 13.3077 364.614 13.3077 365.839 13.3077L652.608 13.3077C653.926 13.3077 655.178 13.3077 656.457 13.3077C662.928 13.1278 667.409 7.54072 663.6 2.92711C662.962 2.18879 662.147 1.55921 661.204 1.07465C660.261 0.59008 659.208 0.260097 658.106 0.103709C657.003 -0.0526785 655.873 -0.0323829 654.78 0.163427C653.687 0.359236 652.653 0.726689 651.738 1.24462C650.42 1.91127 651.646 3.56201 652.925 2.89537Z",
    fill: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_313_140777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.924 33.5824C324.346 29.0492 327.94 24.9808 332.468 21.6463C336.992 24.987 340.586 29.0584 343.012 33.593L332.468 47L321.924 33.5824Z",
    fill: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_313_140777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.298 20.9583C324.072 14.2495 312.671 11.4348 300.348 11.4348L42.2717 11.4348C31.0028 11.4348 19.5231 11.9639 8.26747 11.4348C6.74401 11.4161 5.28514 10.9376 4.18124 10.0944C3.07733 9.25128 2.40934 8.10533 2.31015 6.88466C2.05973 2.65199 7.93795 0.80019 11.9974 2.92711C13.3154 3.59375 14.462 1.94301 13.1968 1.27637C12.2804 0.761177 11.2467 0.396008 10.1545 0.201735C9.0623 0.00746227 7.93315 -0.0121092 6.83154 0.144141C5.72994 0.300392 4.67749 0.629403 3.73433 1.11237C2.79118 1.59533 1.97579 2.22278 1.33481 2.95885C0.18815 4.39226 -0.239922 6.12109 0.136639 7.79763C0.5132 9.47417 1.66647 10.974 3.36453 11.9956C5.31313 13.0188 7.63623 13.4813 9.9545 13.3077L295.695 13.3077C301.93 13.3077 308.019 13.1702 314.147 14.5246C320.655 15.9901 326.648 18.653 331.65 22.3022C332.784 23.1275 334.471 21.7837 333.324 20.9583H333.298Z",
    fill: "#1A1A1A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_313_140777",
    x: 327.247,
    y: 0,
    width: 341.754,
    height: 30.5605,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_313_140777"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_313_140777",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_313_140777",
    x: 317.924,
    y: 21.6465,
    width: 29.0879,
    height: 33.3535,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_313_140777"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_313_140777",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_313_140777",
    x: -3.99707,
    y: 0.0390625,
    width: 341.704,
    height: 30.5215,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_313_140777"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_313_140777",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_313_140777"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 664,
    height: 47,
    fill: "white",
    transform: "translate(664 47) rotate(-180)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecoLineBottom);
export default __webpack_public_path__ + "static/media/decoLineBottom.304f27f2d19385f99cdbff4c1165e8dd.svg";
export { ForwardRef as ReactComponent };